import { render, staticRenderFns } from "./water-pump-off-by-Nick.vue?vue&type=template&id=36587f48&"
import script from "./water-pump-off-by-Nick.vue?vue&type=script&lang=js&"
export * from "./water-pump-off-by-Nick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports